export const messages = {
  en: {
    operationalAnalysis: {
      allCommunities: 'All Communities',
      fetchError: 'Failed to fetch operational analysis data',
      fetchCommunityError: 'Failed to fetch community list',
      chart: {
        payFee: 'Payment Orders',
        repair: 'Repair Orders',
        inspection: 'Inspections',
        maintainance: 'Maintenance',
        itemIn: 'Purchase Orders',
        itemOut: 'Withdrawal Orders',
        carIn: 'Vehicle Entries',
        personIn: 'Door Openings',
        contract: 'Contracts'
      }
    }
  },
  zh: {
    operationalAnalysis: {
      allCommunities: '全部小区',
      fetchError: '获取运营分析数据失败',
      fetchCommunityError: '获取小区列表失败',
chart: {
        payFee: '繳費訂單數',
        repair: '報修訂單數',
        inspection: '巡檢數',
        maintainance: '保養數',
        itemIn: '採購訂單數',
        itemOut: '領用訂單數',
        carIn: '車輛進場數',
        personIn: '開門記錄',
        contract: '簽訂合同數'
      }
    }
  },
  'zh-TW': {
    operationalAnalysis: {
      allCommunities: '全部小區',
      fetchError: '獲取運營分析數據失敗',
      fetchCommunityError: '獲取小區列表失敗',
      chart: {
        payFee: '繳費訂單數',
        repair: '報修訂單數',
        inspection: '巡檢數',
        maintainance: '保養數',
        itemIn: '採購訂單數',
        itemOut: '領用訂單數',
        carIn: '車輛進場數',
        personIn: '開門記錄',
        contract: '簽訂合同數'
      }
    }
  }
}